<template>
    <div class="flex items-center justify-center py-5 bg-a-orange-fe5000" :class="{ 'sticky top-0': fixed === true }">
        <div class="text-white text-15 font-normal font-main leading-22px">
            {{ title }}
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: {
            type: String
        },
        fixed: {
            type: Boolean
        }
    },
    setup: function () {

    }
})
</script>


